"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertContent = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var close_thin_1 = __importDefault(require("adp-react-icons/lib/adp/close-thin"));
var check_circle_1 = __importDefault(require("adp-react-icons/lib/fa/check-circle"));
var info_circle_1 = __importDefault(require("adp-react-icons/lib/fa/info-circle"));
var exclamation_circle_1 = __importDefault(require("adp-react-icons/lib/fa/exclamation-circle"));
var warning_1 = __importDefault(require("adp-react-icons/lib/fa/warning"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var button_1 = require("../button");
var chevron_right_1 = __importDefault(require("adp-react-icons/lib/fa/chevron-right"));
var DEFAULT_TIMEOUT = 4000;
var AlertIcons = {
  'success': {
    icon: react_1.default.createElement(check_circle_1.default, null)
  },
  'info': {
    icon: react_1.default.createElement(info_circle_1.default, null)
  },
  'error': {
    icon: react_1.default.createElement(exclamation_circle_1.default, null)
  },
  'warning': {
    icon: react_1.default.createElement(warning_1.default, null)
  },
  'alert': {
    icon: react_1.default.createElement(warning_1.default, null)
  }
};
var AlertContent = /** @class */function (_super) {
  __extends(AlertContent, _super);
  function AlertContent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.autoCloseTimeoutID = null;
    _this.setAutoCloseTimeout = function () {
      if (_this.autoCloseTimeoutID) {
        return;
      }
      _this.autoCloseTimeoutID = window.setTimeout(function () {
        this.autoCloseTimeoutID = null;
        if (this.props.onClose) {
          this.props.onClose();
        }
      }.bind(_this), DEFAULT_TIMEOUT);
    };
    _this.cancelAutoCloseTimeout = function () {
      if (!_this.autoCloseTimeoutID) {
        return;
      }
      clearTimeout(_this.autoCloseTimeoutID);
      _this.autoCloseTimeoutID = null;
    };
    _this.handleClose = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };
    _this.handleKeyPress = function (k) {
      if (k.key === 'Enter' && _this.props.onClose) {
        _this.props.onClose();
      }
    };
    return _this;
  }
  AlertContent.prototype.componentDidMount = function () {
    if (this.props.autoClose) {
      this.setAutoCloseTimeout();
    }
  };
  AlertContent.prototype.componentWillUnmount = function () {
    this.cancelAutoCloseTimeout();
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  };
  AlertContent.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      size = _b.size,
      type = _b.type,
      animate = _b.animate,
      closeable = _b.closeable,
      alertStyle = _b.alertStyle,
      title = _b.title,
      children = _b.children,
      variableContent = _b.variableContent,
      iconClassName = _b.iconClassName;
    var htmlProps = _1.omit(this.props, Object.keys(AlertContent.propTypes));
    var alertClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('alert')] = true, _a[vdl_prefix_1.vdlPrefix("alert--" + alertStyle + "-style")] = true, _a[vdl_prefix_1.vdlPrefix('alert--animate')] = animate, _a[vdl_prefix_1.vdlPrefix('alert--closeable')] = closeable, _a[vdl_prefix_1.vdlPrefix("alert--" + size)] = true, _a[vdl_prefix_1.vdlPrefix("alert--" + type)] = true, _a);
    var icon = typeof this.props.icon !== 'undefined' ? this.props.icon : AlertIcons[type] && AlertIcons[type].icon;
    var showFontIcon = typeof this.props.icon === 'undefined' && typeof this.props.iconClassName !== 'undefined';
    return react_1.default.createElement("div", __assign({}, htmlProps, {
      key: "alert",
      className: classnames_1.classNames(alertClasses, className),
      id: "alert",
      tabIndex: 0
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__container')
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__icon')
    }, showFontIcon ? react_1.default.createElement("i", {
      className: iconClassName
    }) : icon && icon), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__content-container')
    }, title && react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__title')
    }, title), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__content')
    }, children), variableContent && react_1.default.createElement("div", null, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('insites__link')
    }, react_1.default.createElement(button_1.Button, {
      buttonStyle: 'link'
    }, "VIEW INSIGHTS ", react_1.default.createElement(chevron_right_1.default, null))))), closeable && react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__close'),
      role: "button",
      "aria-label": "This is a close button.",
      id: "alert-close-btn",
      onClick: this.handleClose,
      onKeyPress: this.handleKeyPress,
      tabIndex: 0
    }, react_1.default.createElement(close_thin_1.default, {
      id: "icon-thin-close"
    })), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('alert__bar')
    })));
  };
  AlertContent.propTypes = {
    type: prop_types_1.default.oneOf(['success', 'info', 'warning', 'error', 'alert']),
    size: prop_types_1.default.oneOf(['sm', 'lg']),
    alertStyle: prop_types_1.default.oneOf(['default', 'inline']),
    title: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    closeable: prop_types_1.default.bool,
    variableContent: prop_types_1.default.bool,
    animate: prop_types_1.default.bool,
    autoClose: prop_types_1.default.bool,
    onClose: prop_types_1.default.func,
    onUnmount: prop_types_1.default.func,
    icon: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.oneOf([false])]),
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    iconClassName: prop_types_1.default.string,
    eeAction: prop_types_1.default.string,
    frequency: prop_types_1.default.string,
    dateRange: prop_types_1.default.string
  };
  AlertContent.defaultProps = {
    type: 'info',
    closeable: false,
    variableContent: false,
    animate: true,
    size: 'sm',
    autoClose: false,
    alertStyle: 'default',
    eeAction: undefined,
    frequency: undefined,
    dateRange: undefined
  };
  return AlertContent;
}(react_1.default.Component);
exports.AlertContent = AlertContent;